import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

if (localStorage.getItem('vuex')) {
    let vuex = JSON.parse(localStorage.getItem('vuex'))
    axios.defaults.headers.common["Authorization"] = `Bearer ${vuex.login.token}`;
} else {
    axios.defaults.headers.common["Authorization"] = null;
}

const LOGIN_PATH = '/login';

// Endpoints whose 401 does not mean "the session expired":
//  - login / recovery: they are public, and a 401 there is just wrong
//    credentials, which the login screen already reports on its own.
//  - auth/check: the route guard in routes.js owns that case; letting both
//    react would fire two competing redirects.
const IGNORED_ENDPOINTS = ['auth/login', 'auth/recovery_password', 'auth/check'];

// Several requests run in parallel (the folder views fire a handful at once),
// so without this every one of them would trigger its own redirect.
let isSessionExpiredHandled = false;

function isIgnoredRequest (config)
{
  const url = (config && config.url) || '';
  return IGNORED_ENDPOINTS.some (endpoint => url.indexOf (endpoint) !== -1);
}

function onSessionExpired ()
{
  if (isSessionExpiredHandled) return;
  isSessionExpiredHandled = true;

  localStorage.removeItem ('vuex');
  localStorage.removeItem ('token');
  localStorage.removeItem ('expirationDate');
  localStorage.removeItem ('user');
  axios.defaults.headers.common["Authorization"] = null;

  // A full reload instead of a router push: it is the only way to be sure no
  // view keeps rendering data left over from the expired session.
  window.location.replace (LOGIN_PATH);
}

// Until now an expired session only made each request fail on its own, so the
// user could keep walking through empty admin screens instead of being sent
// back to the login. The route guard does not cover this: it only runs when
// entering /admin from outside, not when moving between its children.
axios.interceptors.response.use (
  response => response,
  error =>
  {
    const status = error.response ? error.response.status : null;
    const isUnauthenticated = status === 401 || status === 419;

    if (isUnauthenticated &&
        !isIgnoredRequest (error.config) &&
        window.location.pathname !== LOGIN_PATH)
    {
      onSessionExpired ();
    }

    return Promise.reject (error);
  }
);

export default axios;
